import { formatTime } from "../../../utils/timeConversion";
import { getVoyageNumber } from "../../../utils/domainSelectors";
import { getSelectedCargo, getSelectedTrip } from "../../../utils/voyageSelection";

const formatRemarks = (remarks, getLabel) => {
  if (typeof remarks === "string") return remarks;
  if (!remarks || typeof remarks !== "object") return "";

  return Object.entries(remarks)
    .filter(([, value]) => value !== "" && value != null)
    .map(([key, value]) => `${getLabel(key)}: ${value}`)
    .join(", ");
};

export const createSofPrintViewModelV2 = ({
  currentVoyage,
  selectedTripId,
  selectedCargoIndex,
  cargoActivities = {},
  getLabel,
  companyLogo,
  is24Hour,
  t,
}) => {
  const selectedTrip = getSelectedTrip(currentVoyage, selectedTripId);
  const selectedCargo = getSelectedCargo(
    currentVoyage,
    selectedTripId,
    selectedCargoIndex
  );

  if (!selectedTrip || !selectedCargo) {
    throw new Error(t("forprint.selectCargoBeforePrint"));
  }

  return {
    title: t("forprint.printSoF"),
    companyLogo: companyLogo || "",
    vesselName: currentVoyage?.vessel || "-",
    voyageNumber: getVoyageNumber(currentVoyage) || "-",
    date: selectedTrip.date || "-",
    port: selectedTrip.from || "-",
    berth: selectedTrip.jetty || "-",
    cargo: selectedCargo.cargo || "-",
    chiefOfficer: selectedTrip.crew?.chiefOfficer || "-",
    generalRemarks: cargoActivities.generalRemarks?.remarks || "",
    activities: Object.entries(cargoActivities)
      .filter(([, details]) => details?.date)
      .map(([activity, details]) => ({
        activity: getLabel(activity) || activity.replace(/-/g, " ").toUpperCase(),
        date: details.date,
        time:
          details.time === "EDP"
            ? "EDP"
            : details.time
              ? formatTime(details.time, is24Hour)
              : "",
        remarks: formatRemarks(details.remarks, getLabel),
      })),
  };
};
